import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Pontuacao } from '../pontuacao/pontuacao';
import { PontuacaoService } from '../pontuacao/pontuacao.service';

@Component({
    templateUrl: './pontuacao-resultado.component.html',
    selector: 'pontuacao-resultado'
})
export class PontuacaoResultadoComponent {
    public isLoading: boolean;
    public mensagemTela: String;
    @Input() pontuacao: Pontuacao;

    // construtor
    constructor(private pontuacaoService: PontuacaoService) {   }

    // ngOnInit é executado ao entrar na tela
    ngOnInit() {

    }

}
